import React, { useState, useCallback } from 'react';
import { ControlLink, Text } from '@moda/om';
import { useIsGuestUser } from '../../../../hooks/useIsGuestUser';
import { ReturnMethodValue } from '../../../../hooks/useReturnSummary';
import { ConvertGuestModal } from '../../../ConvertGuestModal';
import { useAuthModal } from '../../../../hooks/useAuthModal';

interface Props {
  numberOfAvailableReturnMethods: number;
  selectedReturnMethodId: number | null;
}

export const RequestReturnMethodGuestUserFeatures: React.FC<Props> = ({
  numberOfAvailableReturnMethods,
  selectedReturnMethodId
}) => {
  const [convertUserModalOpen, setConvertUserModalOpen] = useState(false);
  const { isGuestUser, isMember } = useIsGuestUser();
  const { openAuthModal } = useAuthModal();

  const handleClick = useCallback(() => {
    if (!isMember) {
      setConvertUserModalOpen(true);
    }

    if (isMember) {
      openAuthModal();
    }
  }, [isMember, openAuthModal]);

  const handleCloseModal = useCallback(() => {
    setConvertUserModalOpen(false);
  }, []);

  if (!isGuestUser) return null;

  if (selectedReturnMethodId !== ReturnMethodValue.SiteCredit) return null;

  return (
    <>
      <Text>
        {numberOfAvailableReturnMethods === 1 &&
          'The item(s) selected for this return are only eligible for Site Credit. '}

        <Text>
          Please{' '}
          <ControlLink onClick={handleClick}>
            {!isMember && 'create an account'}

            {isMember && 'sign in'}
          </ControlLink>{' '}
          with the email used in this purchase to receive your credit.
        </Text>
      </Text>

      {!isMember && (
        <ConvertGuestModal
          onCloseModal={handleCloseModal}
          show={convertUserModalOpen}
          title="Create an account"
        />
      )}
    </>
  );
};
